export default "__VITE_ASSET__DzVidEFH__"